"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelocityCalculationSource = exports.DeveloperBadgeMetric = exports.DeveloperBadge = void 0;
var DeveloperBadge;
(function (DeveloperBadge) {
    DeveloperBadge["LowActivity"] = "LowActivity";
    DeveloperBadge["NeedAttention"] = "NeedAttention";
    DeveloperBadge["TeamPlayer"] = "TeamPlayer";
    DeveloperBadge["OnTheRise"] = "OnTheRise";
    DeveloperBadge["SuperStar"] = "SuperStar";
})(DeveloperBadge = exports.DeveloperBadge || (exports.DeveloperBadge = {}));
var DeveloperBadgeMetric;
(function (DeveloperBadgeMetric) {
    DeveloperBadgeMetric["Velocity"] = "Velocity";
    DeveloperBadgeMetric["HighPriorityTasks"] = "High priority tasks";
    DeveloperBadgeMetric["ReviewedPRs"] = "Reviewed PRs";
    DeveloperBadgeMetric["PRSize"] = "PR size";
    DeveloperBadgeMetric["PRCycleTimeWIPAndReview"] = "PR cycle time WIP and review";
})(DeveloperBadgeMetric = exports.DeveloperBadgeMetric || (exports.DeveloperBadgeMetric = {}));
var VelocityCalculationSource;
(function (VelocityCalculationSource) {
    VelocityCalculationSource["MergedPRs"] = "MergedPRs";
    VelocityCalculationSource["JiraResolvedTasks"] = "JiraResolvedTasks";
})(VelocityCalculationSource = exports.VelocityCalculationSource || (exports.VelocityCalculationSource = {}));
//# sourceMappingURL=developer-badges.js.map